import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { StringLiteralLike } from "typescript";

export interface GuardianInfo {
  id: string;
  nombre: string;
  image_src: string;
  qr_src: string;

  esposa: string;
  sexo: string;
  edad: string;
  hijos: string;
  estado: string;
  educacion: string;
  variedades: string;
  comercio_src: string;

  pais: string;
  region: string;
  provincia: string;
  distrito: string;
  comunidad: string;
  poblado: string;
  detalles: string;
  variedad: string[];
}

@Component({
  selector: "app-guardian-item",
  templateUrl: "./guardian-item.component.html",
  styleUrls: ["./guardian-item.component.css"],
})
export class GuardianItemComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}
  id: any;

  guardian_info_list: GuardianInfo[] = [
    {
      id: "1",
      nombre: "Agapito Cuba",
      image_src: "assets/images/test/guardian/guardian_list/guardians/01.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      esposa: "Agapita Cueva",
      sexo: "Masculino",
      edad: "52",
      hijos: "4",
      estado: "Casado",
      educacion: "Tecnica superior",
      variedades: "80",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
      pais: "Peru",
      region: "Junín",
      provincia: "Huancayo",
      distrito: "San Pedro de Saños",
      comunidad: "Tiso  Saños",
      poblado: "",
      detalles:
        "Cuando era peque habia una gran diversidad de papas y otras que se han ido perdiendo. Ahora las estamos recuperando poco a poco",
      variedad: [
        "Yana huayro",
        "Peruanita",
        "Qillu huayru, Puka awi",
        "Puka promesa",
        "Allka suytu papa",
        "Puka huayru",
        "Muru huayru",
        "Puka ruyru",
        "Callwa",
        "Puka piña",
      ],
    },

    {
      id: "2",
      nombre: "Elberto Montes",
      esposa: "Eleonora Gutierrez",
      sexo: "Masculino",
      edad: "48",
      hijos: "2",
      estado: "casado",
      educacion: "",
      variedades: "200",
      pais: "Peru",
      region: "Huancavelica",
      provincia: "Acobamba",
      distrito: "Paucará",
      comunidad: "Pumaranra",
      poblado: "Tacsanja",
      detalles:
        "Mi familia cultiva las papas nativas desde nuestros abuelos, es una gran herencia que nos han dejado. En el campo mantienen su belleza por que sus flores son de diferente color. Así como la forma, color, pulpa y sabor de sus tubérculos.",
      variedad: [
        "Puka Gaspar",
        "Puma maqui",
        "Yana misipa makin",
        "Muro Gaspar",
        "Trajin waqachi",
        "Yana huayro",
        "Llumchuy waqachi",
        "Murunquis",
        "Papa maswa",
        "Suytu peruanita",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/02.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "3",
      nombre: "Elmer Chavez",
      esposa: "Esperanza Gabriel",
      sexo: "Masculino",
      edad: "52",
      hijos: "4",
      estado: "casado",
      educacion: "",
      variedades: "100",
      pais: "Peru",
      region: "Huancavelica",
      provincia: "Tayacaja",
      distrito: "Pazos",
      comunidad: "Vista Alegre",
      poblado: "Tacsanja",
      detalles: "Nuestras papas son orgánicas, libres de agroquimicos",
      variedad: [
        "Wacapa qallun",
        "Muro epillo",
        "Puka chilluku",
        "Oca papa",
        "Puka camotillo",
        "Azul wacapa qallum",
        "Uku ipillu",
        "Caballo luntu",
        "Runtus",
        "Wenqu",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/03.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "4",
      nombre: "Confesor Marquina",
      esposa: "Agapita Martinez",
      sexo: "Masculino",
      edad: "48",
      hijos: "3",
      estado: "casado",
      educacion: "",
      variedades: "90",
      pais: "Peru",
      region: "La Libertad",
      provincia: "Sánchez Carrión",
      distrito: "Chugay",
      comunidad: "Caserío de La Soledad",
      poblado: "Tacsanja",
      detalles:
        "Somos una comunidad muy unida y todos trabajamos por el bienestar de nuestras familias, yo tengo más de 90 variedades, pero en conjunto tenemos más de 120 variedades de papas nativas con las cuales hemos ganado muchos premios en las ferias agropecuarias de nuestra región ",
      variedad: [
        "Calavera",
        "Lampina negra",
        "Alcona",
        "Charrona",
        "Lampina colorada",
        "Huayro negro",
        "Chano de perro",
        "Yameina colorada",
        "Osa",
        "Santa Rosa",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/04.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "5",
      nombre: "Francisco Salvatierra",
      esposa: "Damiana de la Cruz",
      sexo: "Masculino",
      edad: "56",
      hijos: "8",
      estado: "casado",
      educacion: "",
      variedades: "45",
      pais: "Peru",
      region: "Huancavelica",
      provincia: "Huancavelica",
      distrito: "Yauli",
      comunidad: "Ambato",
      poblado: "Tacsanja",
      detalles:
        "Mi familia cultiva las papas nativas desde nuestros abuelos, es una gran herencia que nos han dejado. En el campo mantienen su belleza por que sus flores son de diferente color. Así como la forma, color, pulpa y sabor de sus tubérculos.",
      variedad: [
        "Yana winqo",
        "Qillu huayru",
        "Muru llumchuy waqachi",
        "Tornillo puka, Masa waqachi",
        "Sirina, Wikqis",
        "Azul aqu suytu, Acero suytu",
        "Allqupa yupin, Angelpa tantan",
        "Añaspa makin",
        "Puka aqu suytu",
        "Masa waqachi",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/05.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "6",
      nombre: "Marcelo Tiza",
      esposa: "Rocio Becerra",
      sexo: "Masculino",
      edad: "56",
      hijos: "6",
      estado: "casado",
      educacion: "",
      variedades: "65",
      pais: "Peru",
      region: "Junín",
      provincia: "Huancayo",
      distrito: "Quilcas",
      comunidad: "Quilcas",
      poblado: "Tacsanja",
      detalles:
        "Cuando yo era niño había una gran diversidad de papas y otras que se han ido perdiendo. Ahora las estamos recuperando poco a poco",
      variedad: [
        "Yana piña",
        "Yana huayro",
        "Amarilla legítima",
        "Camotillo",
        "Muru huayro",
        "Muru cornish",
        "Romano suytu",
        "Ishcupuro",
        "Miship maki",
        "Limeña",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/06.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "7",
      nombre: "Romulo Torres",
      esposa: "Rosalvina Huaman",
      sexo: "Masculino",
      edad: "53",
      hijos: "3",
      estado: "casado",
      educacion: "",
      variedades: "44",
      pais: "Peru",
      region: "Junín",
      provincia: "Jauja",
      distrito: "Masma Chicche",
      comunidad: "Masma Chicche",
      poblado: "Tacsanja",
      detalles:
        "Mi familia cultiva las papas nativas desde nuestros abuelos, es una gran herencia que nos han dejado. En el campo mantienen su belleza por que sus flores son de diferente color. Así como la forma, color, pulpa y sabor de sus tubérculos.",
      variedad: [
        "Muru llumchuy wacachi",
        "Papa leche",
        "Echipsa",
        "Allca epillus",
        "Yana pichi",
        "Acero suytu",
        "Yana llumchuy wacachi",
        "Muro Benito",
        "Huamantanga",
        "Puka Capllush",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/07.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
    {
      id: "8",
      nombre: "Victor Anco",
      esposa: "Luciana Palpa",
      sexo: "Masculino",
      edad: "52",
      hijos: "2",
      estado: "casado",
      educacion: "",
      variedades: "184",
      pais: "Peru",
      region: "Lima",
      provincia: "Huarochiri",
      distrito: "San Mateo",
      comunidad: "Los Quipus",
      poblado: "Tacsanja",
      detalles:
        "Muchas variedades se han perdido porque las familias han dejado de sembrar, somos pocos los que conservamos las diferentes variedades",
      variedad: [
        "Puka culebra",
        "Yana culebra",
        "Pillucho negro",
        "Ojo de mono",
        "Uvas rojo",
        "Muru huayro",
        "Japiacho, Beso de novia",
        "Pillucho blanco",
        "Mishi maki",
        "Piña negra",
      ],
      image_src: "assets/images/test/guardian/guardian_list/guardians/08.jpg",
      qr_src: "assets/images/test/guardian/guardian_list/guardian/qrcode.png",
      comercio_src:
        "assets/images/test/guardian/guardian_list/guardians/001.jpg",
    },
  ];

  guardian_info!: GuardianInfo;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");

    this.fnGetGuardian(this.id);
  }

  public fnGetGuardian(id: string) {
    const _guardian_info = this.guardian_info_list.filter(
      (_guardian_info: GuardianInfo) => {
        return _guardian_info.id == id;

        // return _guardian_info.id == id;
      }
    )[0];

    this.guardian_info = _guardian_info;
  }
}
